import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import _ from 'underscore';
import $ from 'jquery';
import Immutable from 'immutable';
import { injectIntl, FormattedMessage } from 'react-intl';
import StoreInterestMixin from 'lib/flux/store/interest_mixin';
import SessionStore from 'stores/shared/session';
import D13nStore from 'stores/plugins/d13n';
import ContactActionCreator from 'action_creators/contact';
import NumberOfPeopleDropdown from 'views/ui/form_elements/dropdown/guests';
import AvailabilityDatepicker from 'views/plugins/ui/availability_datepicker';
import { capitalize, lowercase, titleize } from 'lib/string_utils';
import classnames from 'classnames';
import validationRules from './validation';

const FormComponent = createReactClass({
  displayName: 'TourPage-ContactGuide-Form',

  mixins: [StoreInterestMixin],

  propTypes: {
    intl: PropTypes.object.isRequired,
    guideId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    tourId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    isCompany: PropTypes.bool,
  },

  getDefaultProps() {
    return {
      isCompany: false,
    };
  },

  getInitialState() {
    return {
      fields: Immutable.Map({
        first_name: '',
        last_name: '',
        email: '',
        from_date: null,
        to_date: null,
        number_of_people: 2,
        message: '',
        tour_id: this.props.tourId,
        guide_id: this.props.guideId,
      }),
      loading: false,
      errors: {},
      messageSent: false,
      csrf: {},
    };
  },

  componentDidMount() {
    this._setValidationRules();
  },

  getStoreInterests() {
    return {
      csrf: 'session.csrf',
      loading: 'contact.sending',
      errors: 'contact.sendingErrors',
    };
  },

  _inputChanged(e) {
    const field = e.target.name;
    const value = e.target.value;
    e.preventDefault();
    this.setState({
      fields: this.state.fields.set(field, value),
    });
  },

  _numberOfPeopleChanged(field, value, text, $el) {
    this.setState({
      fields: this.state.fields.set(field, value),
    });
  },

  _availabilityChanged(fromDate, toDate) {
    this.setState({
      fields: this.state.fields.merge({ from_date: fromDate, to_date: toDate }),
    });
  },

  _submitClicked(e) {
    e.preventDefault();
    if (!this.state.loading && this.isValid()) {
      ContactActionCreator.sendMessage(this._submitParams());
    }
  },

  isValid() {
    return this.refs.form.className.indexOf('error') < 0;
  },

  _setValidationRules() {
    $('.ui.form').form(validationRules);
  },

  _submitParams() {
    return this.state.fields
      .merge({
        csrf: SessionStore._getCSRFToken().value,
      })
      .toJS();
  },

  _datepickerProps() {
    const { intl } = this.props;

    return AvailabilityDatepicker.props({
      fromDate: {
        name: 'from_date',
        placeholder: intl.formatMessage({
          defaultMessage: 'From',
          description: 'Placeholder for the start date picker in contact form',
        }),
        value: this.state.fields.get('from_date'),
        className: 'field TourPage-ContactGuide-Form-CalendarInput',
        disabled: false,
      },
      toDate: {
        name: 'to_date',
        placeholder: intl.formatMessage({
          defaultMessage: 'to',
          description: 'Placeholder for the end date picker in contact form',
        }),
        value: this.state.fields.get('to_date'),
        className: 'field TourPage-ContactGuide-Form-CalendarInput',
        startDate: this.state.fields.get('from_date'),
        disabled: !this.state.fields.get('to_date'),
      },
      className: 'two fields',
      onChange: this._availabilityChanged,
    });
  },

  _renderFormErrors() {
    const { intl } = this.props;
    let formErrors = null;

    if (this.state.errors.base) {
      formErrors = (
        <div className="ui error message">
          <div className="header">{this.state.errors.base}</div>
          <p>
            <FormattedMessage
              defaultMessage="Please make sure you provided all the form details."
              description="Error message instructing user to complete all required form fields"
            />
          </p>
        </div>
      );
    }
    // TODO We should find a way to return the errors from the contact form...
    return formErrors;
  },

  _formClassName() {
    return classnames('ui', 'form', 'TourPage-ContactGuide-Form', {
      error: Object.keys(this.state.errors).length,
    });
  },

  _fieldClassName(name) {
    return classnames('field', {
      error: this.state.errors.hasOwnProperty(name),
    });
  },

  _buttonClassName() {
    return classnames(
      'ui',
      'submit',
      'button',
      'large',
      'TourPage-ContactGuide-submit-button',
      'brand-bg',
      {
        disabled: this.state.loading,
      }
    );
  },

  _numberOfPeopleIcon() {
    return <i className="af-triangle-down-2 icon icon-anyfont" />;
  },

  render() {
    const { intl } = this.props;

    return (
      <div
        data-testid="contact-guide-form"
        ref="form"
        className={this._formClassName()}
      >
        {this._renderFormErrors()}
        <div className="two fields ContactForm-name">
          <div className="field">
            <label>
              <FormattedMessage
                defaultMessage="Name"
                description="Label for the name input field"
              />
            </label>
            <div className={this._fieldClassName('first_name')}>
              <input
                data-testid="firstname-input"
                type="text"
                name="first_name"
                value={this.state.fields.get('first_name')}
                placeholder={intl.formatMessage({
                  defaultMessage: 'First',
                  description: 'Placeholder text for first name input field',
                })}
                onChange={this._inputChanged}
              />
            </div>
          </div>
          <div className="field">
            <label className="hidden">
              {titleize(
                intl.formatMessage({
                  defaultMessage: 'Last name',
                  description: 'Label for last name input field',
                })
              )}
            </label>
            <div className={this._fieldClassName('last_name')}>
              <input
                data-testid="lastname-input"
                type="text"
                name="last_name"
                value={this.state.fields.get('last_name')}
                placeholder={intl.formatMessage({
                  defaultMessage: 'Last',
                  description: 'Placeholder text for last name input field',
                })}
                onChange={this._inputChanged}
              />
            </div>
          </div>
        </div>
        <div className={this._fieldClassName('email')}>
          <label className="first-cap">
            <FormattedMessage
              id="EMAIL_ADDRESS"
              defaultMessage="Email address"
              description="Label for the email address input field"
            />
          </label>
          <input
            data-testid="email-input"
            type="email"
            name="email"
            placeholder={intl.formatMessage({
              defaultMessage: 'Email address',
              description: 'Placeholder text for email address input field',
            })}
            value={this.state.fields.get('email')}
            onChange={this._inputChanged}
          />
        </div>
        <div className="three fields">
          <div className="field extended">
            <label>
              <FormattedMessage
                id="DESIRED_DATES"
                defaultMessage="Desired dates"
                description="Label for the date range picker in contact form"
              />{' '}
              (
              <FormattedMessage
                id="OPTIONAL"
                defaultMessage="Optional"
                description="Indicates that the field is not required"
              />
              )
            </label>
            <AvailabilityDatepicker.component {...this._datepickerProps()} />
          </div>
          <div className="field TourPage-ContactGuide-Form-NumberOfPeopleInput">
            <label className="ContactGuide-num-guests-label">
              {capitalize(
                intl.formatMessage({
                  defaultMessage: 'Number of Guests',
                  description:
                    'Label for the guest count selector in contact form',
                })
              )}{' '}
              <span className="hidden-tablet">
                (
                <FormattedMessage
                  id="OPTIONAL"
                  defaultMessage="Optional"
                  description="Indicates that the field is not required"
                />
                )
              </span>
            </label>
            <NumberOfPeopleDropdown
              value={this.state.fields.get('number_of_people')}
              name="number_of_people"
              onChange={this._numberOfPeopleChanged}
              optionsLabel={lowercase(
                intl.formatMessage({
                  defaultMessage: 'Guest',
                  description: 'Singular form of guest for dropdown options',
                })
              )}
              optionsLabelPlural={lowercase(
                intl.formatMessage({
                  defaultMessage: 'guests',
                  description: 'Plural form of guest for dropdown options',
                })
              )}
              max={500}
              icon={this._numberOfPeopleIcon()}
            />
          </div>
        </div>
        <div className={this._fieldClassName('message')}>
          <label>
            <FormattedMessage
              defaultMessage="How can we help you?"
              description="Label for the message textarea in contact form"
            />
          </label>
          <textarea
            data-testid="message-textarea"
            name="message"
            value={this.state.fields.get('message')}
            placeholder={`${intl.formatMessage({
              defaultMessage: 'Enter your message here',
              description: 'Placeholder text for the message textarea',
            })}...`}
            onChange={this._inputChanged}
          />
        </div>
        <input type="hidden" name="tour_id" value={this.props.tourId} />
        <input type="hidden" name="guide_id" value={this.props.guideId} />
        <div className="TourPage-ContactGuide-Form-actions">
          <button
            data-testid="contact-button"
            className={this._buttonClassName()}
            onClick={this._submitClicked}
          >
            <FormattedMessage
              id="SEND_MESSAGE"
              defaultMessage="Send Message"
              description="Submit button text to send the contact form message"
            />
          </button>
        </div>
      </div>
    );
  },
});

const Form = injectIntl(FormComponent);
export default Form;
